<ng-content select="[icon]"></ng-content>

<div class="content">
  <p
    class="label"
    [onyxTooltip]="label()"
    [onyxTooltipDisabled]="
      overflowHelper.hasNoOverflow.bind(overflowHelper, labelTextElement)
    "
    #labelTextElement
  >
    {{ label() | translate }}
  </p>

  @if (value()) {
    <p
      class="value f-body-m f-medium"
      [onyxTooltip]="value()"
      [onyxTooltipDisabled]="
        overflowHelper.hasNoOverflow.bind(overflowHelper, valueTextElement)
      "
      #valueTextElement
    >
      {{ value() }}
    </p>
  } @else {
    <p class="value f-body-m f-medium">
      <ng-content></ng-content>
    </p>
  }
</div>
